/* Refurbed — storefront theme behaviour
   Storefront chrome, EN/FR/PT interface, catalogue filters, variant pricing,
   Help / Policy / About content. Product data itself comes from the store catalogue. */

(function () {
  'use strict';

  var CONFIG = window.TECHNOW || {};
  var ROUTES = CONFIG.routes || { root: '/', cart: '/cart', cartChange: '/cart/change', search: '/search' };

  /* ------------------------------------------------------------------ i18n */

  var EXTRA = {
    en: {
      noResultsTitle: 'No products found.', noResultsBody: 'Try a different brand or clear your filters.',
      seeAll: 'See the whole catalogue', loading: 'Loading…', notFoundBody: 'This page does not exist or is no longer available.',
      backAllShort: 'Back to all products', configurationNote: 'Every configuration is checked and cleaned before shipping.',
      warrantyIncludedNote: 'A 12-month warranty is included with every device.',
      footerTagline: 'Refurbished technology, checked and guaranteed.',
      footerShipping: 'Delivered within 10 days across Europe with UPS and DPD.',
      addresses: 'Addresses', signOut: 'Sign out', orders: 'Orders', date: 'Date', status: 'Status', account: 'Account', requests: 'Requests', accountSettings: 'Account settings', myOrders: 'My orders', noOrdersYet: 'No orders yet', circularPurchases: 'Your purchases will contribute to the circular economy. They will be visible here.', startShopping: 'Start shopping',
      noOrders: 'You have not placed any orders yet.', shippingAddress: 'Shipping address', billingAddress: 'Billing address',
      newAddress: 'New address', addressLine: 'Address', postalCode: 'Postal code', city: 'City', country: 'Country',
      phone: 'Phone', save: 'Save', lastName: 'Last name', confirmPassword: 'Confirm password',
      activateAccount: 'Activate your account', declineInvitation: 'Decline invitation',
      recoverSent: 'We have sent you an email with a link to reset your password.', resetPassword: 'Reset password',
      tabletCable: 'tablet-compatible USB-C cable', macbookCharger: 'compatible USB-C charger',
      headphoneCable: 'compatible charging cable', soldOut: 'Sold out',
      contactPageTitle: 'Contact us', contactPageIntro: 'Send us your question and the Refurbed team will reply by email.',
      contactFormTitle: 'How can we help?', contactFormIntro: 'Complete the form below. Fields marked with * are required.', contactSuccess: 'Thank you. Your message has been sent successfully.',
      contactName: 'Full name', contactOrderNumber: 'Order number (optional)', contactOrderPlaceholder: '#1001', contactSubject: 'Subject', contactChooseSubject: 'Choose a subject',
      contactTopicProduct: 'Product question', contactTopicOrder: 'Order or delivery', contactTopicReturn: 'Return or refund', contactTopicWarranty: 'Warranty or technical support', contactTopicOther: 'Other',
      contactMessage: 'Message', contactMessagePlaceholder: 'Describe how we can help you…', contactPrivacyNote: 'Your details are used only to answer your request.', contactSend: 'Send message',
      searchSuggestionsLabel: 'Product suggestions', searchLoading: 'Searching…', searchNoProducts: 'No matching products found.', searchViewAll: 'View all search results'
    },
    fr: {
      noResultsTitle: 'Aucun produit trouvé.', noResultsBody: 'Essayez une autre marque ou effacez vos filtres.',
      seeAll: 'Voir tout le catalogue', loading: 'Chargement…', notFoundBody: 'Cette page n’existe pas ou n’est plus disponible.',
      backAllShort: 'Retour à tous les produits', configurationNote: 'Chaque configuration est vérifiée et nettoyée avant l’expédition.',
      warrantyIncludedNote: 'Une garantie de 12 mois est incluse avec chaque appareil.',
      footerTagline: 'La technologie reconditionnée, vérifiée et garantie.',
      footerShipping: 'Livré sous 10 jours partout en Europe avec UPS et DPD.',
      addresses: 'Adresses', signOut: 'Se déconnecter', orders: 'Commandes', date: 'Date', status: 'Statut', account: 'Compte', requests: 'Demandes', accountSettings: 'Paramètres du compte', myOrders: 'Mes commandes', noOrdersYet: 'Aucune commande pour le moment', circularPurchases: 'Vos achats contribueront à l’économie circulaire. Ils seront visibles ici.', startShopping: 'Commencer les achats',
      noOrders: 'Vous n’avez pas encore passé de commande.', shippingAddress: 'Adresse de livraison', billingAddress: 'Adresse de facturation',
      newAddress: 'Nouvelle adresse', addressLine: 'Adresse', postalCode: 'Code postal', city: 'Ville', country: 'Pays',
      phone: 'Téléphone', save: 'Enregistrer', lastName: 'Nom', confirmPassword: 'Confirmer le mot de passe',
      activateAccount: 'Activer votre compte', declineInvitation: 'Refuser l’invitation',
      recoverSent: 'Nous vous avons envoyé un e-mail avec un lien de réinitialisation.', resetPassword: 'Réinitialiser le mot de passe',
      tabletCable: 'câble USB-C compatible avec la tablette', macbookCharger: 'chargeur USB-C compatible',
      headphoneCable: 'câble de charge compatible', soldOut: 'Épuisé',
      contactPageTitle: 'Nous contacter', contactPageIntro: 'Envoyez-nous votre question et l’équipe Refurbed vous répondra par e-mail.',
      contactFormTitle: 'Comment pouvons-nous vous aider ?', contactFormIntro: 'Remplissez le formulaire ci-dessous. Les champs marqués d’un * sont obligatoires.', contactSuccess: 'Merci. Votre message a bien été envoyé.',
      contactName: 'Nom complet', contactOrderNumber: 'Numéro de commande (facultatif)', contactOrderPlaceholder: '#1001', contactSubject: 'Objet', contactChooseSubject: 'Choisissez un objet',
      contactTopicProduct: 'Question sur un produit', contactTopicOrder: 'Commande ou livraison', contactTopicReturn: 'Retour ou remboursement', contactTopicWarranty: 'Garantie ou assistance technique', contactTopicOther: 'Autre',
      contactMessage: 'Message', contactMessagePlaceholder: 'Décrivez comment nous pouvons vous aider…', contactPrivacyNote: 'Vos coordonnées sont utilisées uniquement pour répondre à votre demande.', contactSend: 'Envoyer le message',
      searchSuggestionsLabel: 'Suggestions de produits', searchLoading: 'Recherche…', searchNoProducts: 'Aucun produit correspondant trouvé.', searchViewAll: 'Voir tous les résultats'
    },
    pt: {
      noResultsTitle: 'Nenhum produto encontrado.', noResultsBody: 'Experimente outra marca ou limpe os filtros.',
      seeAll: 'Ver todo o catálogo', loading: 'A carregar…', notFoundBody: 'Esta página não existe ou já não está disponível.',
      backAllShort: 'Voltar a todos os produtos', configurationNote: 'Cada configuração é verificada e limpa antes do envio.',
      warrantyIncludedNote: 'Uma garantia de 12 meses está incluída em cada aparelho.',
      footerTagline: 'Tecnologia recondicionada, verificada e garantida.',
      footerShipping: 'Entregue no prazo de 10 dias em toda a Europa com a UPS e a DPD.',
      addresses: 'Endereços', signOut: 'Terminar sessão', orders: 'Encomendas', date: 'Data', status: 'Estado', account: 'Conta', requests: 'Pedidos', accountSettings: 'Definições da conta', myOrders: 'As minhas encomendas', noOrdersYet: 'Ainda não existem encomendas', circularPurchases: 'As suas compras contribuirão para a economia circular. Ficarão visíveis aqui.', startShopping: 'Começar a comprar',
      noOrders: 'Ainda não efetuou nenhuma encomenda.', shippingAddress: 'Endereço de entrega', billingAddress: 'Endereço de faturação',
      newAddress: 'Novo endereço', addressLine: 'Endereço', postalCode: 'Código postal', city: 'Cidade', country: 'País',
      phone: 'Telefone', save: 'Guardar', lastName: 'Sobrenome', confirmPassword: 'Confirmar palavra-passe',
      activateAccount: 'Ativar a sua conta', declineInvitation: 'Recusar o convite',
      recoverSent: 'Enviámos-lhe um e-mail com um link para redefinir a palavra-passe.', resetPassword: 'Redefinir a palavra-passe',
      tabletCable: 'cabo USB-C compatível com o tablet', macbookCharger: 'carregador USB-C compatível',
      headphoneCable: 'cabo de carregamento compatível', soldOut: 'Esgotado',
      contactPageTitle: 'Contacte-nos', contactPageIntro: 'Envie-nos a sua pergunta e a equipa Refurbed responderá por e-mail.',
      contactFormTitle: 'Como podemos ajudar?', contactFormIntro: 'Preencha o formulário abaixo. Os campos marcados com * são obrigatórios.', contactSuccess: 'Obrigado. A sua mensagem foi enviada com sucesso.',
      contactName: 'Nome completo', contactOrderNumber: 'Número da encomenda (opcional)', contactOrderPlaceholder: '#1001', contactSubject: 'Assunto', contactChooseSubject: 'Escolha um assunto',
      contactTopicProduct: 'Pergunta sobre um produto', contactTopicOrder: 'Encomenda ou entrega', contactTopicReturn: 'Devolução ou reembolso', contactTopicWarranty: 'Garantia ou assistência técnica', contactTopicOther: 'Outro',
      contactMessage: 'Mensagem', contactMessagePlaceholder: 'Descreva como podemos ajudar…', contactPrivacyNote: 'Os seus dados são utilizados apenas para responder ao seu pedido.', contactSend: 'Enviar mensagem',
      searchSuggestionsLabel: 'Sugestões de produtos', searchLoading: 'A pesquisar…', searchNoProducts: 'Nenhum produto correspondente encontrado.', searchViewAll: 'Ver todos os resultados'
    }
  };

  var DICT = (typeof translations !== 'undefined' && translations) ? translations : { en: {}, fr: {}, pt: {} };
  ['en', 'fr', 'pt'].forEach(function (code) {
    DICT[code] = Object.assign({}, DICT[code] || {}, EXTRA[code]);
  });

  var CONDITIONS = {
    en: { Excellent: 'Excellent', 'Very good': 'Very good', Good: 'Good' },
    fr: { Excellent: 'Excellent', 'Very good': 'Très bien', Good: 'Bien' },
    pt: { Excellent: 'Excelente', 'Very good': 'Muito bom', Good: 'Bom' }
  };
  var BADGES = {
    en: { Bestseller: 'Bestseller', 'New arrival': 'New arrival', 'Just a few left': 'Just a few left', Popular: 'Popular', 'Top rated': 'Top rated' },
    fr: { Bestseller: 'Meilleure vente', 'New arrival': 'Nouveauté', 'Just a few left': 'Bientôt épuisé', Popular: 'Populaire', 'Top rated': 'Très bien noté' },
    pt: { Bestseller: 'Mais vendido', 'New arrival': 'Novidade', 'Just a few left': 'Últimas unidades', Popular: 'Popular', 'Top rated': 'Melhor avaliado' }
  };

  var OPTION_NAMES = {
    en: {},
    fr: { 'Condition': 'État', 'Memory (RAM)': 'Mémoire (RAM)', 'Storage': 'Stockage', 'Colour': 'Couleur', 'Color': 'Couleur', 'Connectivity': 'Connectivité', 'Capacity': 'Capacité', 'Battery': 'Batterie', 'Keyboard': 'Clavier', 'SIM': 'SIM', 'Size': 'Taille', 'Title': 'Modèle' },
    pt: { 'Condition': 'Estado', 'Memory (RAM)': 'Memória (RAM)', 'Storage': 'Armazenamento', 'Colour': 'Cor', 'Color': 'Cor', 'Connectivity': 'Conectividade', 'Capacity': 'Capacidade', 'Battery': 'Bateria', 'Keyboard': 'Teclado', 'SIM': 'SIM', 'Size': 'Tamanho', 'Title': 'Modelo' }
  };

  var VALUE_RULES = {
    en: [],
    fr: [
      [/Dual SIM \(physical SIM \+ eSIM\)/g, 'Double SIM (SIM physique + eSIM)'],
      [/Dual SIM \(2 eSIM\)/g, 'Double SIM (2 eSIM)'],
      [/US \(American English\)/g, 'US (anglais américain)'],
      [/PT \(Portuguese\)/g, 'PT (portugais)'],
      [/DE \(German\)/g, 'DE (allemand)'],
      [/FR \(French\)/g, 'FR (français)'],
      [/IT \(Italian\)/g, 'IT (italien)'],
      [/ES \(Spanish\)/g, 'ES (espagnol)'],
      [/Space Grey/g, 'Gris sidéral'],
      [/New battery/g, 'Batterie neuve'],
      [/Very good/g, 'Très bien'],
      [/\bGood\b/g, 'Bien'],
      [/\bOptimal\b/g, 'Optimale'],
      [/\bSilver\b/g, 'Argent'],
      [/\bGold\b/g, 'Or'],
      [/\bgrey\b/g, 'gris'],
      [/\bblack\b/g, 'noir'],
      [/\bwhite\b/g, 'blanc'],
      [/\bblue\b/g, 'bleu'],
      [/\bgreen\b/g, 'vert'],
      [/\bred\b/g, 'rouge'],
      [/(\d)\s?GB\b/g, '$1 Go'],
      [/(\d)\s?TB\b/g, '$1 To']
    ],
    pt: [
      [/Dual SIM \(physical SIM \+ eSIM\)/g, 'Dois SIM (SIM físico + eSIM)'],
      [/Dual SIM \(2 eSIM\)/g, 'Dois SIM (2 eSIM)'],
      [/US \(American English\)/g, 'US (inglês americano)'],
      [/PT \(Portuguese\)/g, 'PT (português)'],
      [/DE \(German\)/g, 'DE (alemão)'],
      [/FR \(French\)/g, 'FR (francês)'],
      [/IT \(Italian\)/g, 'IT (italiano)'],
      [/ES \(Spanish\)/g, 'ES (espanhol)'],
      [/Space Grey/g, 'Cinza sideral'],
      [/New battery/g, 'Bateria nova'],
      [/Very good/g, 'Muito bom'],
      [/\bExcellent\b/g, 'Excelente'],
      [/\bGood\b/g, 'Bom'],
      [/\bOptimal\b/g, 'Ótima'],
      [/\bSilver\b/g, 'Prateado'],
      [/\bGold\b/g, 'Dourado'],
      [/\bgrey\b/g, 'cinza'],
      [/\bblack\b/g, 'preto'],
      [/\bwhite\b/g, 'branco'],
      [/\bblue\b/g, 'azul'],
      [/\bgreen\b/g, 'verde'],
      [/\bred\b/g, 'vermelho']
    ]
  };

  var TEXT_RULES = {
    en: [],
    fr: [
      [/Refurbished ([^(<]+?) \((\d{4})\) — graded /g, '$1 ($2) reconditionné — état '],
      [/, fully tested and cleaned before dispatch\./g, ', entièrement testé et nettoyé avant expédition.'],
      [/Brand:/g, 'Marque :'],
      [/Model year:/g, 'Année du modèle :'],
      [/Customer rating:/g, 'Note client :'],
      [/Further options available on request/g, 'Autres options disponibles sur demande'],
      [/Warranty extension:/g, 'Extension de garantie :'],
      [/\+(\d+) months → (\d+) months total/g, '+$1 mois → $2 mois au total'],
      [/Delivery within 10 days across Europe with UPS and DPD/g, 'Livraison sous 10 jours partout en Europe avec UPS et DPD'],
      [/30-day returns — refund issued within 72 hours of drop-off confirmation/g, 'Retours sous 30 jours — remboursement sous 72 h après confirmation du dépôt du colis'],
      [/Minimum 12-month seller warranty/g, 'Garantie vendeur minimum de 12 mois'],
      [/Memory \(RAM\):/g, 'Mémoire (RAM) :'],
      [/Condition:/g, 'État :'],
      [/Storage:/g, 'Stockage :'],
      [/Colour:/g, 'Couleur :'],
      [/Connectivity:/g, 'Connectivité :'],
      [/Keyboard:/g, 'Clavier :'],
      [/Battery:/g, 'Batterie :'],
      [/Appearance:/g, 'Aspect :'],
      [/Cable:/g, 'Câble :']
    ],
    pt: [
      [/Refurbished ([^(<]+?) \((\d{4})\) — graded /g, '$1 ($2) recondicionado — estado '],
      [/, fully tested and cleaned before dispatch\./g, ', totalmente testado e limpo antes do envio.'],
      [/Brand:/g, 'Marca:'],
      [/Model year:/g, 'Ano do modelo:'],
      [/Customer rating:/g, 'Avaliação dos clientes:'],
      [/Further options available on request/g, 'Outras opções disponíveis sob consulta'],
      [/Warranty extension:/g, 'Extensão de garantia:'],
      [/\+(\d+) months → (\d+) months total/g, '+$1 meses → $2 meses no total'],
      [/Delivery within 10 days across Europe with UPS and DPD/g, 'Entrega em 10 dias em toda a Europa com UPS e DPD'],
      [/30-day returns — refund issued within 72 hours of drop-off confirmation/g, 'Devoluções em 30 dias — reembolso emitido no prazo de 72 horas após a confirmação da entrega do volume'],
      [/Minimum 12-month seller warranty/g, 'Garantia mínima do vendedor de 12 meses'],
      [/Memory \(RAM\):/g, 'Memória (RAM):'],
      [/Condition:/g, 'Estado:'],
      [/Storage:/g, 'Armazenamento:'],
      [/Colour:/g, 'Cor:'],
      [/Connectivity:/g, 'Conectividade:'],
      [/Keyboard:/g, 'Teclado:'],
      [/Battery:/g, 'Bateria:'],
      [/Appearance:/g, 'Aparência:'],
      [/Cable:/g, 'Cabo:']
    ]
  };

  var state = {
    language: 'en',
    chip: 'all',
    conditions: [],
    maxPrice: Infinity,
    sort: 'featured',
    saved: []
  };

  function t(key, replacements) {
    var pack = DICT[state.language] || DICT.en;
    var value = pack[key];
    if (value == null) value = (DICT.en || {})[key];
    if (value == null) return '';
    if (replacements) {
      Object.keys(replacements).forEach(function (name) {
        value = value.split('{' + name + '}').join(replacements[name]);
      });
    }
    return value;
  }

  function translateCondition(label) {
    var pack = CONDITIONS[state.language] || CONDITIONS.en;
    return pack[label] || label;
  }

  function translateBadge(label) {
    var pack = BADGES[state.language] || BADGES.en;
    return pack[label] || translateCondition(label);
  }

  function applyRules(text, rules) {
    (rules || []).forEach(function (rule) { text = text.replace(rule[0], rule[1]); });
    return text;
  }

  function localizeValue(text) {
    if (!text || state.language === 'en') return text;
    return applyRules(text, VALUE_RULES[state.language]);
  }

  function localizeOptionName(name) {
    if (!name) return name;
    var pack = OPTION_NAMES[state.language] || {};
    return pack[name] || localizeValue(name);
  }

  function localizeStoreContent(scope) {
    scope.querySelectorAll('[data-option-name]').forEach(function (node) {
      node.textContent = localizeOptionName(node.dataset.optionName);
    });
    scope.querySelectorAll('[data-option-value]').forEach(function (node) {
      if (node.dataset.rawValue == null) node.dataset.rawValue = node.textContent.trim();
      node.textContent = localizeValue(node.dataset.rawValue);
    });
    scope.querySelectorAll('[data-option-selector] option, [data-variant-select] option').forEach(function (node) {
      if (node.dataset.rawValue == null) node.dataset.rawValue = node.textContent.trim();
      node.textContent = localizeValue(node.dataset.rawValue) + (node.dataset.premium || '');
    });
    scope.querySelectorAll('[data-product-description]').forEach(function (node) {
      if (node.dataset.rawHtml == null) node.dataset.rawHtml = node.innerHTML;
      var html = node.dataset.rawHtml;
      if (state.language !== 'en') {
        html = applyRules(html, TEXT_RULES[state.language]);
        html = applyRules(html, VALUE_RULES[state.language]);
      }
      node.innerHTML = html;
    });
  }

  function applyTranslations(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-i18n]').forEach(function (node) {
      var vars = null;
      Array.prototype.forEach.call(node.attributes, function (attribute) {
        if (attribute.name.indexOf('data-i18n-var-') === 0) {
          vars = vars || {};
          vars[attribute.name.replace('data-i18n-var-', '')] = t(attribute.value) || attribute.value;
        }
      });
      var text = t(node.dataset.i18n, vars);
      if (text) node.textContent = text;
    });
    scope.querySelectorAll('[data-i18n-placeholder]').forEach(function (node) {
      var text = t(node.dataset.i18nPlaceholder);
      if (text) node.setAttribute('placeholder', text);
    });
    scope.querySelectorAll('[data-i18n-title]').forEach(function (node) {
      var text = t(node.dataset.i18nTitle);
      if (text) node.setAttribute('title', text);
    });
    scope.querySelectorAll('[data-i18n-aria]').forEach(function (node) {
      var text = t(node.dataset.i18nAria);
      if (text) node.setAttribute('aria-label', text);
    });
    scope.querySelectorAll('[data-badge]').forEach(function (node) {
      node.textContent = translateBadge(node.dataset.badge);
    });
    scope.querySelectorAll('[data-condition-label]').forEach(function (node) {
      if (node.dataset.rawValue == null) node.dataset.rawValue = node.textContent.trim();
      node.textContent = translateCondition(node.dataset.rawValue);
    });
    localizeStoreContent(scope);
  }

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

  /* --------------------------------------------------------------- toaster */

  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('visible'); }, 2600);
  }

  /* -------------------------------------------------------------- language */

  function storeLocaleFor(language) {
    var locales = CONFIG.storeLocales || [];
    for (var index = 0; index < locales.length; index += 1) {
      var iso = (locales[index].iso || '').toLowerCase();
      if (iso === language || iso.indexOf(language + '-') === 0) return locales[index];
    }
    return null;
  }

  function setLanguage(language, options) {
    if (!DICT[language]) return;
    state.language = language;
    document.documentElement.setAttribute('data-technow-language', language);
    try { localStorage.setItem('techNowLanguage', language); } catch (error) {}

    var menu = document.getElementById('languageMenu');
    if (menu) {
      menu.hidden = true;
      menu.querySelectorAll('[data-language]').forEach(function (button) {
        button.classList.toggle('active', button.dataset.language === language);
      });
    }
    var button = document.getElementById('languageButton');
    if (button) button.setAttribute('aria-expanded', 'false');

    applyTranslations();
    renderInfoPage();
    renderPrivacyPolicyIdentity();
    updateResultCount();
    updatePriceLabel();

    if (options && options.userInitiated) {
      var locale = storeLocaleFor(language);
      var form = document.getElementById('TechNowLocaleForm');
      var input = document.getElementById('TechNowLocaleInput');
      if (locale && form && input) {
        input.value = locale.iso;
        var returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) {
          var separator = '?';
          returnTo.value = window.location.pathname + separator + '_tnlang=' + Date.now();
        }
        form.submit();
      }
    }
  }

  function renderPrivacyPolicyIdentity() { return;
    return;
    if (window.location.pathname.indexOf('/policies/privacy-policy') === -1) return;
    var body = document.querySelector('.shopify-policy__body .rte') || document.querySelector('.shopify-policy__body');
    if (!body) return;

    var previous = body.querySelector('[data-technow-privacy-identity]');
    if (previous) previous.remove();

    body.querySelectorAll('p').forEach(function (node) {
      var text = (node.textContent || '').trim();
      var isUpdated = /^(Last updated|Dernière mise à jour|Última atualização)\s*:?/i.test(text);
      var isController = /^(Data controller|Responsable du traitement|Responsável pelo tratamento)\s*:/i.test(text);
      var isOffice = /^(Registered office|Siège social|Sede social)\s*:/i.test(text);
      var isIde = /^(UID number|IDE number|Numéro UID|Numéro IDE|Número UID|Número IDE)\s*:/i.test(text);
      if (isUpdated || isController || isOffice || isIde) node.remove();
    });

    var identity = document.createElement('div');
    identity.setAttribute('data-technow-privacy-identity', '');
    [t('privacyUpdatedLine'), t('privacyControllerLine'), t('privacyOfficeLine'), t('privacyIdeLine')].forEach(function (line) {
      var paragraph = document.createElement('p');
      paragraph.textContent = line;
      identity.appendChild(paragraph);
    });
    body.insertBefore(identity, body.firstChild);
  }

  function setupLanguagePicker() {
    var button = document.getElementById('languageButton');
    var menu = document.getElementById('languageMenu');
    if (!button || !menu) return;
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('[data-language]').forEach(function (item) {
      item.addEventListener('click', function () {
        setLanguage(item.dataset.language, { userInitiated: true });
      });
    });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !menu.contains(event.target) && event.target !== button) {
        menu.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ------------------------------------------------------ predictive search */

  function setupPredictiveSearch() {
    var form = document.querySelector('.search-box');
    var input = document.getElementById('searchInput');
    var panel = document.getElementById('searchSuggestions');
    var list = document.getElementById('searchSuggestionsList');
    var allLink = document.getElementById('searchSuggestionsAll');
    if (!form || !input || !panel || !list || !allLink) return;

    var timer = null;
    var controller = null;
    var searchRoute = (ROUTES.search || '/search').replace(/\/$/, '');
    var searchCopy = {
      en: { searchSuggestionsLabel: 'Product suggestions', searchLoading: 'Searching…', searchNoProducts: 'No matching products found.', searchViewAll: 'View all search results' },
      fr: { searchSuggestionsLabel: 'Suggestions de produits', searchLoading: 'Recherche…', searchNoProducts: 'Aucun produit correspondant trouvé.', searchViewAll: 'Voir tous les résultats' },
      pt: { searchSuggestionsLabel: 'Sugestões de produtos', searchLoading: 'A pesquisar…', searchNoProducts: 'Nenhum produto correspondente encontrado.', searchViewAll: 'Ver todos os resultados' }
    };

    function searchText(key) {
      var pack = searchCopy[state.language] || searchCopy.en;
      return t(key) || pack[key] || searchCopy.en[key];
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function open() {
      list.setAttribute('aria-label', searchText('searchSuggestionsLabel'));
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function clearList() {
      while (list.firstChild) list.removeChild(list.firstChild);
    }

    function message(text) {
      clearList();
      var note = document.createElement('p');
      note.className = 'search-suggestions-message';
      note.setAttribute('role', 'status');
      note.textContent = text;
      list.appendChild(note);
      allLink.hidden = true;
      open();
    }

    function formatPrice(value) {
      var amount = Number(value);
      if (!isFinite(amount)) return '';
      var locale = state.language === 'fr' ? 'fr-FR' : (state.language === 'pt' ? 'pt-PT' : 'en-GB');
      return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(amount);
    }

    function render(products, query) {
      clearList();
      if (!products.length) {
        message(searchText('searchNoProducts'));
        return;
      }

      products.forEach(function (product, index) {
        var option = document.createElement('a');
        option.className = 'search-suggestion';
        option.href = product.url;
        option.id = 'searchSuggestion' + index;
        option.setAttribute('role', 'option');

        var imageWrap = document.createElement('span');
        imageWrap.className = 'search-suggestion-image';
        if (product.featured_image && product.featured_image.url) {
          var image = document.createElement('img');
          image.src = product.featured_image.url;
          image.alt = product.featured_image.alt || product.title || '';
          image.loading = 'lazy';
          imageWrap.appendChild(image);
        }

        var copy = document.createElement('span');
        copy.className = 'search-suggestion-copy';
        var title = document.createElement('strong');
        title.textContent = product.title || '';
        var meta = document.createElement('small');
        var type = product.type || product.product_type || '';
        meta.textContent = [product.vendor, type].filter(Boolean).join(' · ');
        copy.appendChild(title);
        if (meta.textContent) copy.appendChild(meta);

        var price = document.createElement('span');
        price.className = 'search-suggestion-price';
        price.textContent = formatPrice(product.price_min != null ? product.price_min : product.price);

        option.appendChild(imageWrap);
        option.appendChild(copy);
        if (price.textContent) option.appendChild(price);
        list.appendChild(option);
      });

      allLink.href = searchRoute + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last&type=product';
      allLink.hidden = false;
      allLink.textContent = searchText('searchViewAll');
      open();
    }

    function request() {
      var query = input.value.trim();
      if (query.length < 2) {
        if (controller) controller.abort();
        close();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      message(searchText('searchLoading'));
      var url = searchRoute + '/suggest.json?q=' + encodeURIComponent(query) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=6' +
        '&resources%5Boptions%5D%5Bprefix%5D=last&resources%5Boptions%5D%5Bunavailable_products%5D=last';

      fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          if (input.value.trim() !== query) return;
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          render(Array.isArray(products) ? products : [], query);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError' && input.value.trim() === query) message(searchText('searchNoProducts'));
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(request, 160);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && list.childNodes.length) open();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !panel.hidden) {
        var first = list.querySelector('[role="option"]');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    list.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Escape') return;
      event.preventDefault();
      var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      var index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { close(); input.focus(); return; }
      if (!options.length) return;
      index = event.key === 'ArrowDown' ? (index + 1) % options.length : (index - 1 + options.length) % options.length;
      options[index].focus();
    });
    form.addEventListener('submit', close);
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) close();
    });
  }

  /* ------------------------------------------------------- category panel */

  function setupCategoryPanel() {
    var button = document.getElementById('mobileMenuButton');
    var panel = document.getElementById('categoryMenu');
    var overlay = document.getElementById('categoryMenuOverlay');
    var close = document.getElementById('categoryMenuClose');
    if (!button || !panel) return;

    function open() {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
      if (overlay) overlay.classList.add('visible');
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
    function shut() {
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      if (overlay) overlay.classList.remove('visible');
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }

    button.addEventListener('click', function () {
      panel.classList.contains('open') ? shut() : open();
    });
    if (close) close.addEventListener('click', function () { shut(); button.focus(); });
    if (overlay) overlay.addEventListener('click', shut);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('open')) { shut(); button.focus(); }
    });
  }

  /* ------------------------------------------------------------- catalogue */

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
  }

  function loadFavourites() {
    try {
      state.saved = JSON.parse(localStorage.getItem('techNowFavourites') || '[]');
    } catch (error) { state.saved = []; }
  }

  function saveFavourites() {
    try { localStorage.setItem('techNowFavourites', JSON.stringify(state.saved)); } catch (error) {}
  }

  function paintFavourites() {
    cards().forEach(function (card) {
      var button = card.querySelector('[data-favourite]');
      if (!button) return;
      var active = state.saved.indexOf(button.dataset.favourite) !== -1;
      button.classList.toggle('saved', active);
      button.textContent = active ? '\u2665' : '\u2661';
      button.setAttribute('aria-label', active ? t('removeFavourite') : t('addFavourite'));
    });
  }

  function updateResultCount() {
    var label = document.getElementById('resultCount');
    if (!label) return;
    var visible = cards().filter(function (card) { return !card.hidden; }).length;
    var noun = visible === 1 ? t('itemOne') : t('itemMany');
    var text = t('resultCount', { count: visible, noun: noun });
    label.textContent = text || (visible + ' ' + noun);
  }

  function updatePriceLabel() {
    var slider = document.getElementById('priceRange');
    var output = document.getElementById('priceValue');
    if (!slider || !output) return;
    output.textContent = euro.format(Number(slider.value));
  }

  function applyFilters() {
    var list = cards();
    if (!list.length) return;

    list.forEach(function (card) {
      var price = Number(card.dataset.price || 0);
      var brand = (card.dataset.brand || '').toLowerCase();
      var condition = card.dataset.condition || '';
      var matchesChip = state.chip === 'all' || brand === state.chip.toLowerCase();
      var matchesPrice = price <= state.maxPrice;
      var matchesCondition = state.conditions.length === 0 || state.conditions.indexOf(condition) !== -1;
      card.hidden = !(matchesChip && matchesPrice && matchesCondition);
    });

    var grid = document.querySelector('[data-product-grid]');
    if (grid && state.sort !== 'featured') {
      var sorted = list.slice().sort(function (a, b) {
        if (state.sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (state.sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (state.sort === 'newest') {
          var yearDiff = Number(b.dataset.year || 0) - Number(a.dataset.year || 0);
          if (yearDiff !== 0) return yearDiff;
          return Number(b.dataset.published || 0) - Number(a.dataset.published || 0);
        }
        return 0;
      });
      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    var visible = list.filter(function (card) { return !card.hidden; }).length;
    var empty = document.getElementById('emptyState');
    if (empty) empty.hidden = visible !== 0;
    if (grid) grid.hidden = visible === 0;
    updateResultCount();
  }

  function clearFilters() {
    state.chip = 'all';
    state.conditions = [];
    document.querySelectorAll('[data-chip]').forEach(function (chip) {
      chip.classList.toggle('active', chip.dataset.chip === 'all');
    });
    document.querySelectorAll('.condition-filter').forEach(function (box) { box.checked = false; });
    var slider = document.getElementById('priceRange');
    if (slider) {
      slider.value = slider.max;
      state.maxPrice = Number(slider.max);
      updatePriceLabel();
    }
    applyFilters();
  }

  function setupCatalogue() {
    var list = cards();
    if (!list.length) return;

    list.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-favourite]') || event.target.closest('a')) return;
        if (card.dataset.url) window.location.href = card.dataset.url;
      });
      card.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && card.dataset.url) {
          event.preventDefault();
          window.location.href = card.dataset.url;
        }
      });
      var favourite = card.querySelector('[data-favourite]');
      if (favourite) {
        favourite.addEventListener('click', function (event) {
          event.stopPropagation();
          event.preventDefault();
          var id = favourite.dataset.favourite;
          var index = state.saved.indexOf(id);
          if (index === -1) state.saved.push(id); else state.saved.splice(index, 1);
          saveFavourites();
          paintFavourites();
          showToast(index === -1 ? t('savedFavourite') : t('removedFavourite'));
        });
      }
    });

    loadFavourites();
    paintFavourites();

    var prices = list.map(function (card) { return Math.ceil(Number(card.dataset.price || 0)); });
    var slider = document.getElementById('priceRange');
    if (slider && prices.length) {
      var max = Math.max.apply(null, prices);
      var min = Math.min.apply(null, prices);
      slider.min = String(Math.max(0, Math.floor(min / 50) * 50));
      slider.max = String(Math.ceil(max / 50) * 50);
      slider.step = '10';
      slider.value = slider.max;
      state.maxPrice = Number(slider.max);
      updatePriceLabel();
      slider.addEventListener('input', function () {
        state.maxPrice = Number(slider.value);
        updatePriceLabel();
        applyFilters();
      });
    }

    document.querySelectorAll('[data-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.chip = chip.dataset.chip;
        document.querySelectorAll('[data-chip]').forEach(function (item) { item.classList.remove('active'); });
        chip.classList.add('active');
        applyFilters();
      });
    });

    document.querySelectorAll('.condition-filter').forEach(function (box) {
      box.addEventListener('change', function () {
        state.conditions = Array.prototype.slice.call(document.querySelectorAll('.condition-filter:checked'))
          .map(function (item) { return item.value; });
        applyFilters();
      });
    });

    var sort = document.getElementById('sortSelect');
    if (sort) {
      sort.addEventListener('change', function () {
        state.sort = sort.value;
        applyFilters();
      });
    }

    var filtersButton = document.getElementById('filtersButton');
    var filtersPanel = document.getElementById('filtersPanel');
    if (filtersButton && filtersPanel) {
      filtersButton.addEventListener('click', function () {
        var open = filtersPanel.hidden;
        filtersPanel.hidden = !open;
        filtersButton.setAttribute('aria-expanded', String(open));
        var label = filtersButton.querySelector('.filters-button-label');
        if (label) label.textContent = open ? t('hideFilters') : t('showFilters');
      });
    }

    var clear = document.getElementById('clearFilters');
    if (clear) clear.addEventListener('click', clearFilters);
    var emptyClear = document.getElementById('emptyClear');
    if (emptyClear) emptyClear.addEventListener('click', clearFilters);

    applyFilters();
  }

  /* ---------------------------------------------------------- product page */

  function setupProductPage() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var json = form.querySelector('[data-variant-json]');
    var variants = [];
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch (error) { variants = []; }
    }
    var master = form.querySelector('[data-variant-select]');
    var selectors = Array.prototype.slice.call(form.querySelectorAll('[data-option-selector]'));
    var priceNode = form.querySelector('[data-detail-price]');
    var compareNode = form.querySelector('[data-detail-compare]');
    var compareLine = form.querySelector('[data-compare-line]');
    var discountNode = form.querySelector('[data-discount]');
    var availability = form.querySelector('[data-availability]');
    var addButton = form.querySelector('[data-add-button]');
    var subtitle = document.querySelector('[data-product-subtitle]');
    var mainImage = document.querySelector('[data-main-product-image]');
    var warranties = Array.prototype.slice.call(form.querySelectorAll('[data-warranty]'));

    function money(cents) {
      var value = Number(cents || 0) / 100;
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    }

    function currentVariant() {
      if (!selectors.length) return variants[0];
      var chosen = selectors.map(function (select) { return select.value; });
      for (var index = 0; index < variants.length; index += 1) {
        var options = variants[index].options || [];
        var same = true;
        for (var position = 0; position < chosen.length; position += 1) {
          if (options[position] !== chosen[position]) { same = false; break; }
        }
        if (same) return variants[index];
      }
      return null;
    }

    function updateOptionPremiums(baseVariant) {
      if (!baseVariant) return;
      var chosen = selectors.map(function (select) { return select.value; });
      selectors.forEach(function (select, optionPosition) {
        Array.prototype.slice.call(select.options).forEach(function (option) {
          var candidate = chosen.slice();
          candidate[optionPosition] = option.value;
          var matching = variants.find(function (variant) {
            return (variant.options || []).every(function (value, index) { return value === candidate[index]; });
          });
          var delta = matching ? Number(matching.price) - Number(baseVariant.price) : 0;
          option.dataset.premium = delta ? ' (' + (delta > 0 ? '+' : '−') + money(Math.abs(delta)) + ')' : '';
          var raw = option.dataset.rawValue == null ? option.textContent.trim() : option.dataset.rawValue;
          option.dataset.rawValue = raw;
          option.textContent = localizeValue(raw) + option.dataset.premium;
        });
      });
    }

    function selectedWarrantyCents() {
      var selected = warranties.find(function (warranty) { return warranty.checked; });
      return selected ? Number(selected.dataset.warrantyCents || 0) : 0;
    }

    function update() {
      var variant = currentVariant();
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.querySelector('[data-i18n]').textContent = t('soldOut');
        }
        return;
      }
      if (master) master.value = String(variant.id);
      updateOptionPremiums(variant);
      var warrantyCents = selectedWarrantyCents();
      if (priceNode) priceNode.textContent = money(Number(variant.price) + warrantyCents);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareNode) compareNode.textContent = money(Number(variant.compare_at_price) + warrantyCents);
        if (discountNode) {
          discountNode.textContent = String(Math.round((1 - variant.price / variant.compare_at_price) * 100));
        }
        if (compareLine) compareLine.hidden = false;
      } else if (compareLine) {
        compareLine.hidden = true;
      }
      if (subtitle) {
        subtitle.textContent = (variant.options || []).map(function (option) {
          return localizeValue(translateCondition(option));
        }).join(' | ');
      }
      if (availability) {
        availability.innerHTML = variant.available
          ? '\u2713 <span data-i18n="available">' + t('available') + '</span>'
          : '<span data-i18n="soldOut">' + t('soldOut') + '</span>';
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        var label = addButton.querySelector('[data-i18n]');
        if (label) label.textContent = variant.available ? t('addToCart') : t('soldOut');
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) { thumb.classList.remove('active'); });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selectors.forEach(function (select) { select.addEventListener('change', update); });
    warranties.forEach(function (warranty) {
      warranty.addEventListener('change', function () {
        if (warranty.checked) warranties.forEach(function (other) { if (other !== warranty) other.checked = false; });
        update();
      });
    });
    update();

    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImage && thumb.dataset.full) mainImage.src = thumb.dataset.full;
      });
    });
  }

  /* -------------------------------------------------------------- cart page */

  function setupCartPage() {
    document.querySelectorAll('[data-cart-link]').forEach(function (button) {
      button.addEventListener('click', function () {
        window.location.href = button.dataset.cartLink;
      });
    });
  }

  /* ------------------------------------------------------ information pages */

  function policyMarkup() {
    return '<a class="app-page-back" href="' + ROUTES.root + '">\u2190 ' + t('backStore') + '</a>' +
      '<header class="info-hero"><span>Refurbed</span><h1>' + t('policiesTitle') + '</h1><p>' + t('policiesBody') + '</p><p class="policy-last-updated">' + t('policyLastUpdated') + '</p></header>' +
      '<div class="info-card-grid">' +
      '<article><span>\u25B0</span><h2>' + t('policyDeliveryTitle') + '</h2><p>' + t('policyDeliveryBody') + '</p></article>' +
      '<article><span>\u21A9</span><h2>' + t('policyReturnsTitle') + '</h2><p>' + t('policyReturnsBody') + '</p></article>' +
      '<article><span>\u2662</span><h2>' + t('policyWarrantyTitle') + '</h2><p>' + t('policyWarrantyBody') + '</p></article>' +
      '<article><span>\u233E</span><h2>' + t('policyPrivacyTitle') + '</h2><p>' + t('policyPrivacyBody') + '</p></article>' +
      '<article><span>\u2302</span><h2>' + t('policyRegisteredOfficeTitle') + '</h2><p>' + t('policyRegisteredOfficeBody') + '</p></article>' +
      '</div>';
  }

  function aboutMarkup() {
    return '<a class="app-page-back" href="' + ROUTES.root + '">\u2190 ' + t('backStore') + '</a>' +
      '<header class="info-hero about-hero"><span>Refurbed</span><h1>' + t('aboutTitle') + '</h1><p>' + t('aboutBody') + '</p></header>' +
      '<div class="info-card-grid about-cards">' +
      '<article><span>\u267B</span><h2>' + t('aboutMissionTitle') + '</h2><p>' + t('aboutMissionBody') + '</p></article>' +
      '<article><span>\u2713</span><h2>' + t('aboutQualityTitle') + '</h2><p>' + t('aboutQualityBody') + '</p></article>' +
      '<article><span>\u25C7</span><h2>' + t('aboutPromiseTitle') + '</h2><p>' + t('aboutPromiseBody') + '</p></article>' +
      '</div>';
  }

  function helpMarkup() {
    var data = (typeof helpFaqData !== 'undefined' && helpFaqData) ? (helpFaqData[state.language] || helpFaqData.en) : [];
    var groups = data.map(function (group) {
      var sections = group.sections.map(function (section) {
        var items = section.items.map(function (pair) {
          return '<details class="faq-question" data-faq-question><summary><span>\uFF0B</span>' + pair[0] + '</summary><p>' + pair[1] + '</p></details>';
        }).join('');
        return '<details class="faq-category" data-faq-category><summary><span class="faq-category-icon">' + section.icon +
          '</span><b>' + section.title + '</b><span class="faq-chevron">\u2304</span></summary><div class="faq-questions">' + items + '</div></details>';
      }).join('');
      return '<div class="faq-group" data-faq-group><h3>' + t(group.group) + '</h3>' + sections + '</div>';
    }).join('');

    return '<a class="app-page-back" href="' + ROUTES.root + '">\u2190 ' + t('backStore') + '</a>' +
      '<div class="help-hero"><p>' + t('helpCentre') + '</p><h1>' + t('helpSearch') + '</h1>' +
      '<label><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.2-3.2"></path></svg>' +
      '<input id="helpSearchInput" type="search" placeholder="' + t('helpSearchPlaceholder') + '" /></label></div>' +
      '<section class="faq-content"><h2>' + t('faqTitle') + '</h2>' + groups +
      '<p id="helpNoResults" class="help-no-results" hidden>' + t('noHelpResults') + '</p></section>' +
      '<div class="help-contact-grid"><article><h3>' + t('needOrderHelp') + '</h3><p>' + t('orderHelpBody') + '</p>' +
      '<a href="' + (ROUTES.login || '/account/login') + '">' + t('goAccount') + '</a></article>' +
      '<article><h3>' + t('supportService') + '</h3><p>' + t('supportServiceBody') + '</p>' +
      '<a href="' + (ROUTES.contact || '/pages/contact') + '">' + t('contactUs') + '</a></article></div>';
  }

  function bindHelpSearch(container) {
    var input = container.querySelector('#helpSearchInput');
    if (!input) return;
    input.addEventListener('input', function () {
      var query = input.value.trim().toLocaleLowerCase(state.language);
      var results = 0;
      container.querySelectorAll('[data-faq-category]').forEach(function (category) {
        var matches = 0;
        category.querySelectorAll('[data-faq-question]').forEach(function (question) {
          var hit = !query || question.textContent.toLocaleLowerCase(state.language).indexOf(query) !== -1;
          question.hidden = !hit;
          if (hit) matches += 1;
        });
        category.hidden = matches === 0;
        category.open = Boolean(query && matches);
        results += matches;
      });
      container.querySelectorAll('[data-faq-group]').forEach(function (group) {
        group.hidden = !group.querySelector('[data-faq-category]:not([hidden])');
      });
      var none = container.querySelector('#helpNoResults');
      if (none) none.hidden = results !== 0;
    });
  }

  function renderInfoPage() {
    var host = document.querySelector('[data-technow-info]');
    if (!host) return;
    var target = host.querySelector('[data-info-target]');
    if (!target) return;
    var kind = host.dataset.technowInfo;
    if (kind === 'policies') target.innerHTML = policyMarkup();
    else if (kind === 'about') target.innerHTML = aboutMarkup();
    else {
      target.innerHTML = helpMarkup();
      bindHelpSearch(target);
    }
  }

  /* ------------------------------------------------------------- account UI */

  function setupRecoverToggle() {
    var login = document.getElementById('LoginBlock');
    var recover = document.getElementById('RecoverBlock');
    if (!login || !recover) return;
    if (window.location.hash === '#recover') { login.hidden = true; recover.hidden = false; }
    document.querySelectorAll('[data-recover-toggle]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var showRecover = recover.hidden;
        recover.hidden = !showRecover;
        login.hidden = showRecover;
      });
    });
  }

  /* ------------------------------------------------- entrance animations */

  var REVEAL_SELECTORS = [
    '.breadcrumb-row', '.intro', '.model-chips', '.filters-button', '.listing-toolbar',
    '.product-card', '.promo-card', '.technow-more', '.collection-card', '.article-card',
    '.detail-breadcrumb', '.detail-title-block', '.detail-gallery', '.product-description',
    '.configuration-panel', '.purchase-panel', '.product-benefits',
    '.info-hero', '.info-card-grid > article', '.help-hero', '.faq-group',
    '.help-contact-grid > article', '.contact-card',
    '.cart-heading', '.cart-line', '.cart-summary', '.cart-assurances', '.empty-cart-card',
    '.auth-card', '.auth-reference-panel', '.profile-dashboard', '.site-footer'
  ].join(', ');

  function setupEntranceAnimations() {
    var root = document.documentElement;
    if (!root.classList.contains('tn-motion')) return;
    root.setAttribute('data-tn-revealed', '1');

    var nodes = [].slice.call(document.querySelectorAll(REVEAL_SELECTORS));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('tn-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, self) {
      var step = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var node = entry.target;
        node.style.setProperty('--tn-delay', Math.min(step, 7) * 55 + 'ms');
        node.classList.add('tn-in');
        step += 1;
        self.unobserve(node);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });

    nodes.forEach(function (node) { observer.observe(node); });

    /* Anything still untouched after the first moments is shown anyway. */
    window.setTimeout(function () {
      nodes.forEach(function (node) {
        if (node.classList.contains('tn-in')) return;
        var box = node.getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) node.classList.add('tn-in');
      });
    }, 1200);
  }

  /* ------------------------------------------------------------------- init */

  function init() {
    var stored = null;
    try { stored = localStorage.getItem('techNowLanguage'); } catch (error) {}
    var initial = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0] || stored || CONFIG.defaultLanguage || 'en';

    var current = (CONFIG.storeLocales || []).filter(function (locale) { return locale.current; })[0];
    if (current && !DICT[initial]) {
      var iso = (current.iso || '').toLowerCase().split('-')[0];
      if (DICT[iso]) initial = iso;
    }

    setupEntranceAnimations();
    setupLanguagePicker();
    setupPredictiveSearch();
    setupCategoryPanel();
    setupCatalogue();
    setupProductPage();
    setupCartPage();
    setupRecoverToggle();
    setLanguage(DICT[initial] ? initial : 'en');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
